// uuid
function S4() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}

/**
 * 基于伪随机数生成 UUID
 * 
 * 生成一个符合 UUID v4 格式的字符串（但不完全符合 RFC 4122 标准）。
 * 格式：xxxxxxxx-xxxx-4xxx-xxxx-xxxxxxxxxxxx
 * 
 * @returns 生成的 UUID 字符串
 * @example
 * ```typescript
 * const id = uuid()
 * console.log(id) // 例如: 'a1b2c3d4-e5f6-4a7b-8c9d-0e1f2a3b4c5d'
 * ```
 */
export function uuid() {
  // 使用数组和 join 方法来优化 uuid 的生成
  const parts = [S4(), S4(), '4' + S4().substring(0, 3), S4(), S4(), S4() + S4() + S4()]
  return parts.join('-').toLowerCase()
}
